<div class="material-theme-login">
  <module-container [customStyle]="{ 'margin-top': 0, padding: '0.8vw' }">
    <div class="controller-container">
      <div *ngIf="currentInputDocument == undefined">
        <button mat-raised-button color="accent" (click)="getNextFile()" [disabled]="isloading">
          Start Job
        </button>
      </div>
      <div *ngIf="currentInputDocument != undefined">
        <button mat-raised-button color="warn" (click)="releaseFile()" [disabled]="isloading">
          Stop Job
        </button>
      </div>
      <div class="job-title-container">
        <span>Category Data Job</span>
      </div>
    </div>
  </module-container>
</div>

<div class="job-container" *ngIf="currentInputDocument != undefined">
  <div class="invoice-configuration-container" *ngIf="hasUuid">
    <div [style.width]="pdfWidth == null ? '100%' : pdfWidth + 'px'" class="file-container">
      <module-container type="full-height">
        <pdf-viewer [uuid]="uuid" (pdfWidth)="changePdfWidth($event)"></pdf-viewer>
      </module-container>
    </div>

    <div class="invoice-form-container">
      <mat-horizontal-stepper (selectionChange)="stepChanged($event, stepper)" #stepper>
        <mat-step>
          <module-container>
            <div class="form-container">
              <form [formGroup]="configForm" (ngSubmit)="submitCategoryData()">
                <h3 class="form-header">Category Data</h3>

                <mat-form-field appearance="outline">
                  <mat-label>Store</mat-label>
                  <input
                    class="store-value-input"
                    matInput
                    readonly="true"
                    [value]="storeVal"
                    disabled
                  />
                </mat-form-field>

                <mat-form-field color="primary" class="mapping-input-field" appearance="outline">
                  <mat-label>ABN / Supplier</mat-label>
                  <input
                    type="text"
                    (input)="mappingInput($event)"
                    matInput
                    formControlName="mapping"
                    [matAutocomplete]="mapping"
                  />
                  <button
                    type="button"
                    *ngIf="mappingText === '' && !hasMappingSelected"
                    (click)="onGenerateABN()"
                    mat-stroked-button
                    matSuffix
                    aria-label="generate"
                  >
                    Generate
                  </button>
                  <mat-autocomplete
                    (optionSelected)="onMappingLookupSelected($event.option.value)"
                    #mapping="matAutocomplete"
                  >
                    <mat-option
                      class="autoCompleteOptions"
                      *ngFor="let lookup of mappingLookup"
                      [value]="lookup"
                      color="primary"
                    >
                      <strong>{{ lookup.abn }}</strong
                      ><br />{{ lookup.supplierName
                      }}{{ lookup.keyword != null ? ' : ' + lookup.keyword : '' }}
                    </mat-option>
                  </mat-autocomplete>

                  <button
                    *ngIf="
                      !hasMappingSelected &&
                      mappingLookup != undefined &&
                      mappingLookup.length == 0 &&
                      mappingText.length > 0
                    "
                    type="button"
                    class="config-button"
                    click-stop-propagation
                    matStepperNext
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip="Add Supplier Mapping"
                      matTooltipClass="action-tooltip"
                      >library_add</mat-icon
                    >
                  </button>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Document type</mat-label>
                  <mat-select
                    formControlName="documentType"
                    (selectionChange)="configureDocNumConfig()"
                  >
                    <mat-option
                      class="selectFormOption"
                      *ngFor="let documentType of documentTypes"
                      [value]="documentType.value"
                    >
                      {{ documentType.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Document Number</mat-label>
                  <input matInput formControlName="documentNumber" placeholder="Document Number" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Document Date</mat-label>
                  <input
                    matInput
                    (input)="imputFormatDate($event.target.value)"
                    #docDate
                    autocomplete="off"
                    [max]="maxDate"
                    formControlName="documentDate"
                    placeholder="Document Date"
                  />
                  <mat-datepicker-toggle
                    class="selectFormOption"
                    matSuffix
                    [for]="dp"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #dp></mat-datepicker>
                  <input
                    type="hidden"
                    [matDatepicker]="dp"
                    placeholder="Choose a date"
                    (dateChange)="toFormattedDate($event.value)"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Stamp</mat-label>
                  <mat-select formControlName="stamp">
                    <mat-option class="selectFormOption" [value]="">None</mat-option>
                    <mat-option
                      class="selectFormOption"
                      *ngFor="let stamp of stamps"
                      [value]="stamp.value"
                    >
                      {{ stamp.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Department</mat-label>
                  <mat-select
                    formControlName="department"
                    (selectionChange)="validateDepartmentSelect($event)"
                  >
                    <ng-container *ngFor="let department of departments">
                      <mat-option class="selectFormOption" [value]="department.label">
                        {{ department.label }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </mat-form-field>

                <div
                  *ngIf="configForm.controls['department'].hasError('departmentInvalid')"
                  class="required-message"
                >
                  Please select a valid department.
                </div>

                <div *ngIf="isDepartmentRequired" class="required-message">
                  Note: Current Document requires a department.
                </div>
                <div class="form-actions">
                  <div class="submit-button-container">
                    <button
                      mat-flat-button
                      class="submit-button"
                      [ngClass]="'submit-button-' + categorySubButton.ButtonStatus"
                      type="submit"
                      color="accent"
                      [disabled]="configForm.invalid || categorySubButton.isSubmitting"
                    >
                      {{ !configForm.invalid ? categorySubButton.ButtonText : 'Fill out details' }}
                      <mat-icon matSuffix>{{ categorySubButton.ButtonIcon }}</mat-icon>
                    </button>
                    <span
                      *ngIf="categorySubButton.ErrorMessage != undefined"
                      class="error-message"
                      >{{ categorySubButton.ErrorMessage }}</span
                    >
                    <mat-progress-bar
                      *ngIf="categorySubButton.isSubmitting"
                      mode="indeterminate"
                    ></mat-progress-bar>
                  </div>
                </div>
              </form>

              <div *ngIf="hasConfigured">
                <h3 class="configuration-heading">
                  Supplier store configuration
                  <button
                    type="button"
                    (click)="stepperstep(stepper, 3)"
                    [disabled]="!supplierStoreConfigButton.ButtonIsClickable"
                    [ngClass]="
                      'configuration-button-' +
                      (supplierStoreConfigButton.ButtonIsClickable ? 'enabled' : 'disabled')
                    "
                    click-stop-propagation
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip=""
                      matTooltipClass="action-tooltip"
                    >
                      {{ supplierStoreConfigButton.ButtonIcon }}
                    </mat-icon>
                  </button>
                </h3>

                <h3 class="configuration-heading">
                  Supplier type configuration
                  <button
                    type="button"
                    (click)="stepperstep(stepper, 4)"
                    [disabled]="!supplierTypeConfigButton.ButtonIsClickable"
                    [ngClass]="
                      'configuration-button-' +
                      (supplierTypeConfigButton.ButtonIsClickable ? 'enabled' : 'disabled')
                    "
                    click-stop-propagation
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip=""
                      matTooltipClass="action-tooltip"
                    >
                      {{ supplierTypeConfigButton.ButtonIcon }}
                    </mat-icon>
                  </button>
                </h3>

                <h3 class="configuration-heading">
                  Supplier store type configuration
                  <button
                    type="button"
                    (click)="stepperstep(stepper, 5)"
                    [disabled]="!supplierStoreTypeConfigButton.ButtonIsClickable"
                    [ngClass]="
                      'configuration-button-' +
                      (supplierStoreTypeConfigButton.ButtonIsClickable ? 'enabled' : 'disabled')
                    "
                    click-stop-propagation
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip=""
                      matTooltipClass="action-tooltip"
                    >
                      {{ supplierStoreTypeConfigButton.ButtonIcon }}
                    </mat-icon>
                  </button>
                </h3>

                <div class="finish-button-container" *ngIf="checkIfFinished()">
                  <button
                    (click)="finishJob(false)"
                    mat-flat-button
                    class="finish-button"
                    type="button"
                    color="accent"
                  >
                    Finish and Exit
                  </button>
                  <button
                    (click)="finishJob(true)"
                    mat-flat-button
                    class="finish-button"
                    type="button"
                    color="accent"
                  >
                    Finish and Next Job
                  </button>
                </div>
              </div>
            </div>
          </module-container>

          <div class="category-job-button-container">
            <!--            <module-container>-->
            <div class="button-container">
              <button mat-stroked-button (click)="onDiscardClick()" [disabled]="isloading">
                Discard
              </button>
              <button mat-stroked-button (click)="onAllocateClick()" [disabled]="isloading">
                Allocate
              </button>
              <button mat-stroked-button (click)="onRescanClick()" [disabled]="isloading">
                Rescan
              </button>
              <button
                mat-stroked-button
                (click)="onSendToStaffOrSupervisor()"
                [disabled]="isloading"
              >
                {{ btnSendDocumentLabel }}
              </button>
            </div>
            <!--            </module-container>-->
          </div>
        </mat-step>

        <!-- Supplier Mapping Form - Step 1 -->
        <mat-step>
          <module-container>
            <div class="form-container">
              <button
                mat-flat-button
                class="back-button"
                type="button"
                (click)="stepperstep(stepper, 0)"
              >
                Back
              </button>
              <form
                [formGroup]="supplierMappingForm"
                (ngSubmit)="submitSupplierMappingConfiguration(stepper)"
              >
                <h3 class="form-header">Supplier Mapping</h3>

                <mat-progress-bar *ngIf="abnButtonDisabled" mode="indeterminate"></mat-progress-bar>
                <mat-form-field color="primary" class="abn-input-field" appearance="outline">
                  <mat-label>ABN</mat-label>
                  <input
                    type="text"
                    (keypress)="abnCheck($event)"
                    (input)="abnInput($event.target.value)"
                    matInput
                    formControlName="abn"
                    [matAutocomplete]="abn"
                  />
                  <mat-autocomplete
                    (optionSelected)="onAbnSelected($event.option.value)"
                    #abn="matAutocomplete"
                  >
                    <mat-option
                      class="autoCompleteOptions"
                      *ngFor="let abnlooked of abnLookup"
                      [value]="abnlooked"
                      color="primary"
                    >
                      <strong>{{ abnlooked.abn }}</strong>
                    </mat-option>
                  </mat-autocomplete>
                  <button
                    *ngIf="abnCreateIsValid"
                    type="button"
                    class="config-button"
                    (click)="addAbn()"
                    click-stop-propagation
                    [disabled]="abnButtonDisabled"
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip="Add Global Abn"
                      matTooltipClass="action-tooltip"
                    >
                      {{ abnButtonIcon }}
                    </mat-icon>
                  </button>
                  <mat-icon *ngIf="abnIsSelected" matSuffix>check</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Key</mat-label>
                  <input matInput formControlName="supplierKey" placeholder="Supplier Key" />
                </mat-form-field>

                <mat-form-field
                  color="primary"
                  class="global-supplier-input-field"
                  appearance="outline"
                >
                  <mat-label>Global Supplier</mat-label>
                  <input
                    type="text"
                    (input)="globalSupplierInput($event)"
                    matInput
                    formControlName="globalSupplier"
                    [matAutocomplete]="globalSupplier"
                  />
                  <mat-autocomplete
                    (optionSelected)="onGlobalSupplierSelected($event.option.value)"
                    #globalSupplier="matAutocomplete"
                  >
                    <mat-option
                      class="autoCompleteOptions"
                      *ngFor="let globalSupplier of globalSupplierLookup"
                      [value]="globalSupplier"
                      color="primary"
                    >
                      <strong
                        >{{ globalSupplier.supplierName }} : {{ globalSupplier.supplierName }} :
                        {{ globalSupplier.supplierName }}</strong
                      >
                    </mat-option>
                  </mat-autocomplete>

                  <mat-icon *ngIf="globalSupplierIsSelected" class="global-supplier-check" matSuffix
                    >check</mat-icon
                  >

                  <button
                    *ngIf="
                      !globalSupplierIsSelected &&
                      globalSupplierLookup != undefined &&
                      globalSupplierLookup.length == 0 &&
                      globalSupTextValue.length > 0
                    "
                    type="button"
                    class="config-button"
                    click-stop-propagation
                    matStepperNext
                  >
                    <mat-icon
                      matTooltipPosition="above"
                      matTooltip="Add Global Supplier"
                      matTooltipClass="action-tooltip"
                      >person_add</mat-icon
                    >
                  </button>
                </mat-form-field>

                <div class="submit-button-container">
                  <button
                    mat-flat-button
                    class="submit-button"
                    [ngClass]="'submit-button-' + supMappingSubButton.ButtonStatus"
                    type="submit"
                    color="accent"
                    [disabled]="
                      supplierMappingForm.invalid ||
                      !abnIsSelected ||
                      !globalSupplierIsSelected ||
                      supMappingSubButton.isSubmitting
                    "
                  >
                    {{
                      !supplierMappingForm.invalid && abnIsSelected && globalSupplierIsSelected
                        ? supMappingSubButton.ButtonText
                        : 'Fill out details'
                    }}
                    <mat-icon matSuffix>{{ supMappingSubButton.ButtonIcon }}</mat-icon>
                  </button>
                  <span
                    *ngIf="supMappingSubButton.ErrorMessage != undefined"
                    class="error-message"
                    >{{ supMappingSubButton.ErrorMessage }}</span
                  >
                  <mat-progress-bar
                    *ngIf="supMappingSubButton.isSubmitting"
                    mode="indeterminate"
                  ></mat-progress-bar>
                </div>
              </form>
            </div>
          </module-container>
        </mat-step>

        <!-- Global Supplier Creating - Step 2 -->
        <mat-step>
          <module-container>
            <div class="form-container">
              <button
                mat-flat-button
                class="back-button"
                type="button"
                (click)="stepperstep(stepper, 1)"
              >
                Back
              </button>
              <form [formGroup]="supplierForm" (ngSubmit)="submitSupplierConfiguration(stepper)">
                <h3 class="form-header">Global Supplier</h3>

                <mat-form-field appearance="outline">
                  <mat-label>Supplier Name</mat-label>
                  <input matInput formControlName="supplierName" placeholder="Supplier Name" />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Invoice Supplier Name</mat-label>
                  <input matInput formControlName="invoiceSupplierName" placeholder="Invoice Supplier Name" />
                </mat-form-field>

                <div class="submit-button-container">
                  <button
                    mat-flat-button
                    class="submit-button"
                    [ngClass]="'submit-button-' + globalSupSubButton.ButtonStatus"
                    type="submit"
                    color="accent"
                    [disabled]="supplierForm.invalid || globalSupSubButton.isSubmitting"
                  >
                    {{
                      !supplierForm.invalid ? globalSupSubButton.ButtonText : 'Fill out supplier'
                    }}
                    <mat-icon matSuffix>{{ globalSupSubButton.ButtonIcon }}</mat-icon>
                  </button>
                  <span
                    *ngIf="globalSupSubButton.ErrorMessage != undefined"
                    class="error-message"
                    >{{ globalSupSubButton.ErrorMessage }}</span
                  >
                  <mat-progress-bar
                    *ngIf="globalSupSubButton.isSubmitting"
                    mode="indeterminate"
                  ></mat-progress-bar>
                </div>
              </form>
            </div>
          </module-container>
        </mat-step>

        <!-- Supplier store configuration - Step 3 -->
        <mat-step>
          <module-container>
            <div class="form-container">
              <button
                mat-flat-button
                class="back-button"
                type="button"
                (click)="stepperstep(stepper, 0)"
              >
                Back
              </button>
              <form
                [formGroup]="storeSupplierForm"
                (ngSubmit)="submitStoreSupplierConfiguration(stepper)"
              >
                <h3 class="form-header">Supplier store configuration</h3>

                <mat-form-field
                  color="primary"
                  class="store-supplier-input-field"
                  appearance="outline"
                >
                  <mat-label>Store Supplier</mat-label>
                  <input
                    type="text"
                    (input)="storeSupplierInput($event)"
                    matInput
                    formControlName="storeSupplier"
                    [matAutocomplete]="storeSupplier"
                  />
                  <mat-autocomplete
                    (optionSelected)="onStoreSupplierSelected($event.option.value)"
                    #storeSupplier="matAutocomplete"
                  >
                    <mat-option
                      class="autoCompleteOptions"
                      *ngFor="let storeSupplier of storeSupLookup"
                      [value]="storeSupplier"
                      color="primary"
                    >
                      <strong
                        >{{ storeSupplier.supplierCode }} : {{ storeSupplier.supplierName }}:
                        {{ storeSupplier.activeProductsCount }}</strong
                      >
                    </mat-option>
                  </mat-autocomplete>
                  <mat-icon *ngIf="storeSupIsSelected" class="store-supplier-check" matSuffix
                    >check</mat-icon
                  >
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Document Number Supplier Prefix</mat-label>
                  <input
                    matInput
                    formControlName="documentNumberSupplierPrefix"
                    maxlength="15"
                    placeholder="Prefix"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Clean Credit Line Items?</mat-label>
                  <mat-select formControlName="cleanCreditLineItems">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Freight PLU Ex GST</mat-label>
                  <input
                    (keypress)="pluCheck($event)"
                    matInput
                    formControlName="freightPluExGst"
                    placeholder="Ex GST"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Freight PLU Inc GST</mat-label>
                  <input
                    (keypress)="pluCheck($event)"
                    matInput
                    formControlName="freightPluIncGst"
                    placeholder="Inc GST"
                  />
                </mat-form-field>

                <div class="submit-button-container">
                  <button
                    mat-flat-button
                    class="submit-button"
                    [ngClass]="'submit-button-' + storeSupSubButton.ButtonStatus"
                    type="submit"
                    color="accent"
                    [disabled]="storeSupplierForm.invalid || !storeSupIsSelected"
                  >
                    {{
                      !storeSupplierForm.invalid
                        ? storeSupSubButton.ButtonText
                        : 'Fill out supplier'
                    }}
                    <mat-icon matSuffix>{{ storeSupSubButton.ButtonIcon }}</mat-icon>
                  </button>
                  <span *ngIf="storeSupSubButton.ErrorMessage != undefined" class="error-message">{{
                    storeSupSubButton.ErrorMessage
                  }}</span>
                  <mat-progress-bar
                    *ngIf="storeSupSubButton.isSubmitting"
                    mode="indeterminate"
                  ></mat-progress-bar>
                </div>
              </form>
            </div>
          </module-container>
        </mat-step>

        <!-- Supplier type configuration - Step 4 -->
        <mat-step>
          <module-container>
            <div class="form-container">
              <button
                mat-flat-button
                class="back-button"
                type="button"
                (click)="stepperstep(stepper, 0)"
              >
                Back
              </button>
              <form [formGroup]="lineItemsForm" (ngSubmit)="submitLineItemsConfiguration(stepper)">
                <h3 class="form-header">Supplier type configuration</h3>

                <mat-form-field appearance="outline">
                  <mat-label>Skip line items?</mat-label>
                  <mat-select formControlName="skipLineItems">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="submit-button-container">
                  <button
                    mat-flat-button
                    class="submit-button"
                    [ngClass]="'submit-button-' + lineItemsSubButton.ButtonStatus"
                    type="submit"
                    color="accent"
                    [disabled]="lineItemsForm.invalid"
                  >
                    {{
                      !lineItemsForm.invalid ? lineItemsSubButton.ButtonText : 'Fill out supplier'
                    }}
                    <mat-icon matSuffix>{{ lineItemsSubButton.ButtonIcon }}</mat-icon>
                  </button>
                  <span
                    *ngIf="lineItemsSubButton.ErrorMessage != undefined"
                    class="error-message"
                    >{{ lineItemsSubButton.ErrorMessage }}</span
                  >
                  <mat-progress-bar
                    *ngIf="lineItemsSubButton.isSubmitting"
                    mode="indeterminate"
                  ></mat-progress-bar>
                </div>
              </form>
            </div>
          </module-container>
        </mat-step>

        <!-- Supplier store type configuration - Step 5 -->
        <mat-step>
          <module-container>
            <div class="form-container">
              <button
                mat-flat-button
                class="back-button"
                type="button"
                (click)="stepperstep(stepper, 0)"
              >
                Back
              </button>
              <form
                [formGroup]="supStoreTypeConfigurationForm"
                (ngSubmit)="submitSupStoreTypeConfiguration(stepper)"
              >
                <h3 class="form-header">Supplier store type configuration</h3>

                <mat-form-field appearance="outline">
                  <mat-label>Default Priority 0 - 100</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="defaultPriority"
                    placeholder="Priority"
                    min="0"
                    max="100"
                  />
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Default Order Flag</mat-label>
                  <mat-select formControlName="defaultOrderFlag">
                    <mat-option
                      class="selectFormOption"
                      *ngFor="let flag of defaultOrderFlags"
                      [value]="flag.value"
                    >
                      {{ flag.value }} : {{ flag.label }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Is Document Discarded?</mat-label>
                  <mat-select formControlName="isDocumentDiscarded">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Is Edi Configured?</mat-label>
                  <mat-select formControlName="isEdiConfigured">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Is Purchase Order Number Required?</mat-label>
                  <mat-select formControlName="isPurchaseOrderNumberRequired">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Is Autocomplete Allowed?</mat-label>
                  <mat-select formControlName="isAutocompleteAllowed">
                    <mat-option class="selectFormOption" [value]="true">Yes</mat-option>
                    <mat-option class="selectFormOption" [value]="false">No</mat-option>
                  </mat-select>
                </mat-form-field>

                <div class="submit-button-container">
                  <button
                    mat-flat-button
                    class="submit-button"
                    [ngClass]="'submit-button-' + supStoreTypeSubButton.ButtonStatus"
                    type="submit"
                    color="accent"
                    [disabled]="supStoreTypeConfigurationForm.invalid"
                  >
                    {{
                      !supStoreTypeConfigurationForm.invalid
                        ? supStoreTypeSubButton.ButtonText
                        : 'Fill out supplier'
                    }}
                    <mat-icon matSuffix>{{ supStoreTypeSubButton.ButtonIcon }}</mat-icon>
                  </button>
                  <span
                    *ngIf="supStoreTypeSubButton.ErrorMessage != undefined"
                    class="error-message"
                    >{{ supStoreTypeSubButton.ErrorMessage }}</span
                  >
                  <mat-progress-bar
                    *ngIf="supStoreTypeSubButton.isSubmitting"
                    mode="indeterminate"
                  ></mat-progress-bar>
                </div>
              </form>
            </div>
          </module-container>
        </mat-step>
      </mat-horizontal-stepper>

      <ng-template #discardConfirmationDialog let-dialogRef="dialogRef">
        <div class="dialog-close-container">
          <button mat-icon-button [mat-dialog-close]="false">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <h2 mat-dialog-title>Are you sure you want to discard?</h2>
        <div mat-dialog-actions class="dialog-actions">
          <button mat-button [mat-dialog-close]="false">No</button>
          <button mat-raised-button color="warn" [mat-dialog-close]="true">Yes</button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
